import { APP_CONFIG } from '@src/core';

import { LogoMode } from '../types';
import { BASE_PATH_LOGO } from '../constants';
import { AppConfigType } from '../../app-config';

/**
 * Получение ссылки на логотип
 * @param appConfig конфигурация приложения (приходит с бэка)
 * @param mode режим логотипа (маленькое квадратное или большое прямоугольное)
 * @param isDarkTheme тема приложения (true - тёмная, false - светлая)
 */
export const getLogoSrc = (appConfig: AppConfigType, mode: LogoMode = 'logo', isDarkTheme: boolean): string => {
  let apiUrl = '';
  if (mode === 'logo') {
    apiUrl = BASE_PATH_LOGO + (isDarkTheme ? appConfig.logoDark : appConfig.logo);
  }

  if (mode === 'header-logo') {
    apiUrl = BASE_PATH_LOGO + (isDarkTheme ? appConfig.headerLogoDark : appConfig.headerLogo);
  }

  return !!apiUrl ? `${APP_CONFIG.baseUrl}/${apiUrl}` : 'logo';
};
